import {
  academic_year,
  webcourses,
  get_course_type,
  signup_once,
  mycourses,
  validate,
  webcourse_detail,
  course_last,
  course_evaluate,
  records,
  public_courses_year,
  public_courses_my,
  public_courses_list,
  public_courses_signup_once,
  public_courses_detail,
  public_courses_recordProgress,
  public_courses_facecompare,
  checkPubliccourse,
  public_courses_examList,
  public_courses_examResult

} from '@/api/course'
const course = {
  state: {
    // academic_year: [],
  },
  mutations: {

  },
  actions: {
    /**
     * 获取学年
     * @param {*} context
     * @param {*} data
     */
    academic_year({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        academic_year(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取学年
     * @param {*} context
     * @param {*} data
     */
    webcourses({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        webcourses(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 立即报名
     * @param {*} context
     * @param {*} data
     */
    get_course_type({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        get_course_type(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 立即报名
     * @param {*} context
     * @param {*} data
     */
    signup_once({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        signup_once(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 立即报名
     * @param {*} context
     * @param {*} data
     */
    validate({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        validate(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },


    /**
     * 我的课程
     * @param {*} context
     * @param {*} data
     */
    mycourses({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        mycourses(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },


    /**
     * 详情课程
     * @param {*} context
     * @param {*} data
     */
    webcourse_detail({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          webcourse_detail(params).then(response => {
            const {
              data
            } = response;
            resolve(data)
          }).catch(error => {
            reject(error)
          })
        })
      },

      /**
     * 详情课程
     * @param {*} context
     * @param {*} data
     */
    records({
        commit
      }, params) {
        return new Promise((resolve, reject) => {
          records(params).then(response => {
            const {
              data
            } = response;
            resolve(data)
          }).catch(error => {
            reject(error)
          })
        })
      },


      /**
     * 评价弹窗
     * @param {*} context
     * @param {*} data
     */
    course_evaluate({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        course_evaluate(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 最后一节课提示弹窗
     * @param {*} context
     * @param {*} data
     */
    course_last({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        course_last(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 我的公需课-获取学年
     * @param {*} context
     * @param {*} data
     */
    public_courses_year({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        public_courses_year(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 我的公需课列表
     * @param {*} context
     * @param {*} data
     */
    public_courses_my({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        public_courses_my(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 全部公需课列表
     * @param {*} context
     * @param {*} data
     */
    public_courses_list({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        public_courses_list(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 我的公需课-报名
     * @param {*} context
     * @param {*} data
     */
    public_courses_signup_once({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        public_courses_signup_once(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 公需课详情
     * @param {*} context
     * @param {*} data
     */
    public_courses_detail({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        public_courses_detail(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 公需课上报进度
     * @param {*} context
     * @param {*} data
     */
    public_courses_recordProgress({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        public_courses_recordProgress(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 公需课人脸识别
     * @param {*} context
     * @param {*} data
     */
    public_courses_facecompare({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        public_courses_facecompare(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 公需课人脸识别
     * @param {*} context
     * @param {*} data
     */
    public_courses_facecompare({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        public_courses_facecompare(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 公需课评价是否最后一课
     * @param {*} context
     * @param {*} data
     */
    checkPubliccourse({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        checkPubliccourse(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 公需课试题列表
     * @param {*} context
     * @param {*} data
     */
    public_courses_examList({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        public_courses_examList(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 公需课答题结果
     * @param {*} context
     * @param {*} data
     */
    public_courses_examResult({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        public_courses_examResult(params).then(response => {
          const {
            data
          } = response;
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

  }

}

export default course



// WEBPACK FOOTER //
// ./src/store/modules/course.js